import { render, staticRenderFns } from "./OrganisationSelection.vue?vue&type=template&id=3451b975&scoped=true&"
import script from "./OrganisationSelection.vue?vue&type=script&lang=js&"
export * from "./OrganisationSelection.vue?vue&type=script&lang=js&"
import style0 from "./OrganisationSelection.vue?vue&type=style&index=0&id=3451b975&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3451b975",
  null
  
)

export default component.exports